import React, { useState, useEffect } from "react";
import "./../css/master.css";
import "./../css/internalPo.css";
import Header from "./../js/header.js";
import axiosInstance from '../api/csAxios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
var queryString = require("querystring");

var httpURL = "";

const BuyerAppSetup = () => {
  const [days, setDays] = useState(0);
  const [loader, setLoader] = useState("none");
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    httpURL = window.httpURL;
    console.log("httpURL= " + httpURL);
    getDays();
  }, []);

  function getDays(cb) {
    setLoader("block");
    setOpacity(0.5);
    console.log(httpURL + "/a/mst/setup/buyer_app/dtls");
    axiosInstance
      .get(httpURL + "/a/mst/setup/buyer_app/dtls", { withCredentials: true })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          console.log(response.data.buyerAppSetup.daysAfterPoCompletion);
          console.log(typeof response.data.buyerAppSetup.daysAfterPoCompletion);
          setDays(response.data.buyerAppSetup.daysAfterPoCompletion);
        } else {
          toast.error(response.data.SvcMsg);
          //   if (response.data.SvcMsg == "No Internal PO exist")
          setDays(0);

          if (response.data.SvcMsg == "You are not logged in") {
            window.location.href = window.CSURL;
            return false;
          }
        }
        setLoader("none");
        setOpacity(1);
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });
  }
  function save(cb) {
    setLoader("block");
    setOpacity(0.5);
    var daysAfterPoCompletion = { daysAfterPoCompletion: days };
    axiosInstance
      .post(
        httpURL + "/a/mst/setup/buyer_app/save",
        queryString.stringify({
          buyerAppSetup: JSON.stringify(daysAfterPoCompletion),
        }),
        { withCredentials: true }
      )
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          toast.success(response.data.SvcMsg);
        } else {
          toast.error(response.data.SvcMsg);

          if (response.data.SvcMsg == "You are not logged in") {
            window.location.href = window.CSURL;
            return false;
          }
        }
        setLoader("none");
        setOpacity(1);
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });
  }
  return (
    <div style={{ height: "100%" }}>
      <Header />
      <ToastContainer autoClose={2000} hideProgressBar />
      <div
        style={{
          position: "fixed",
          width: 100,
          height: 100,
          marginLeft: -50,
          marginTop: -50,
          left: "50%",
          top: "50%",
          display: loader,
        }}
      >
        <img src={require("../images/loader.gif")} alt="Loader..." />
      </div>
      <div
        className="main"
        style={{
          opacity: opacity,
          pointerEvents: loader == "none" ? "auto" : "none",
        }}
      >
        <div className="container-fluid">
          <div className="col-sm-12 col-centered">
            <div
              className="col-sm-6 col-centered"
              style={{
                width: "50%",
                margin: "0 auto",
                background: "#fff",
                border: "1px solid #ccc",
                borderRadius: 10,
                padding: 10,
                height: 60,
              }}
            >
              <div className="row">
                <label
                  className="control-label col-sm-6"
                  htmlFor="inp_fromDate"
                  style={{ top: 5 }}
                >
                  Stop showing completed IPOs after
                </label>
                <div className="col-sm-6">
                  <div className="col-sm-3">
                    <input
                      type="number"
                      className="form-control"
                      value={days}
                      onChange={(e) => setDays(e.target.value)}
                      placeholder="days"
                    />
                  </div>
                  <div className="col-sm-7 ">
                    <button
                      type="button"
                      className="btn btn-warning"
                      onClick={() => save()}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyerAppSetup;
